export default __webpack_public_path__ + "images/IJ.249cb76.png";